export const CREATE_MODULE  = 'CREATE_MODULE';
export const GET_MODULES  = 'GET_MODULES';
export const GET_MODULES_STRUCTURE  = 'GET_MODULES_STRUCTURE';
export const MODULE_REQUEST  = 'MODULE_REQUEST';
export const DELETE_MODULE  = 'DELETE_MODULE';
export const UPDATE_MODULE  = 'UPDATE_MODULE';
export const MODULE_REQUEST_FAILURE  = 'MODULE_REQUEST_FAILURE';
export const SET_PINNED_MODULES  = 'SET_PINNED_MODULES';